
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discounts/[brand]",
      function () {
        return require("private-next-pages/discounts/[brand]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discounts/[brand]"])
      });
    }
  